export const SubstancesCategory = {
    TOBACCO : "tobacco",
    VAPE : "vape",
    CANNABIS : "cannabis",
    ALCOHOL : "alcohol",
    STIMULANTS : "stimulants",
    OPIOIDS : "opioids",
    SEDATIVES : "sedatives",
    HALLUCINOGENS : "hallucinogens",
    INHALANTS : "inhalants",
    OTHER : "other",
}
export const SubstanceBehaviorEnum = {
  DEPENDENT: "dependent",
  ANXIETY_STRESS: "anxiety_stress",
  SOCIAL: "social",
  ORAL_FIXATION: "oral_fixation",
  STIMULATION: "stimulation",
  HABIT: "habit",
  RECREATIONAL: "recreational",
  COPING: "coping",
  CONFORMITY: "conformity",
  ENHANCEMENT: "enhancement",
  CURIOSITY: "curiosity",
  SPIRITUAL: "spiritual",
  ANALGESIA: "analgesia",
  ESCAPISM_SEDATION: "escapism_sedation",
};
